import * as React from 'react';
import { keyframes } from 'styled-components';
import styled from '../theme';

import DancingManDrag from '../assets/dancing-man-drag.svg';

const rotate360 = keyframes`
  from {
    transform: rotate(0deg) translate(-50%, -50%);
  }

  to {
    transform: rotate(360deg) translate(-50%, -50%);
  }
`;

const fadeIn = keyframes`
 from {
   opacity: 0;
   transform: translate(-50%, -55%);
  }

  to {
    opacity: 1;
    transform: translate(-50%, -50%);
  }
`;

const Image = styled.img`
  position: fixed;
  top: 50%;
  left: 50%;
  animation: ${rotate360} 2s linear infinite 0.05s;
  width: 100vw;
  contain: strict;
  transform: translate(-50%, -50%);
  pointer-events: none;
`;

const Text = styled.div`
  opacity: 0;
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  font-size: 200%;
  contain: content;
  animation-name: ${fadeIn};
  animation-delay: 0.1s;
  animation-duration: 0.3s;
  animation-timing-function: cubic-bezier(0.77, 0, 0.175, 1);
  animation-iteration-count: 1;
  animation-fill-mode: forwards;
  pointer-events: none;
`;

class FixedGlobalLoader extends React.Component {
  render() {
    return (
      <>
        <Image src={DancingManDrag} />
        <Text>Loading...</Text>
      </>
    );
  }
}

export default FixedGlobalLoader;



// WEBPACK FOOTER //
// ./src/components/FixedGlobalLoader.tsx